<template>
  <div class="control-section card-control-section basic_card_layout">
    <div class="e-card-resize-container">
      <div class="row">
        <div class="row card-layout">
          <div
            v-for="(item, index) of datacards"
            v-bind:key="index"
            class="col-xs-6 col-sm-6 col-lg-4 col-md-6"
          >
            <div tabindex="0" class="e-card" id="basic_card" style="border:none">
              <div class="e-card-content" style="height:200px;">
                <div
                  class="text-align"
                  style="height:42px;border-bottom:1px solid #eee;margin-bottom: 10px;"
                >
                  <div
                    style="float:left;line-height: 40px;float: left;font-size: 18px;text-indent: 5px;color: #1890ff;"
                  >{{item.k8sName}}</div>
                  <div class="h-toolbarBg">
                    <ejs-toolbar style="float:right;">
                      <button
                        v-if='synBoolean'
                        class="e-btn e-tbar-btn icon hero-icon hero-icon-synchronize"
                        title="同步"
                        @click="syncnodes(item)"
                      />
                      <button
                        v-if='detailsBoolean'
                        class="e-btn e-tbar-btn icon hero-icon hero-icon-details"
                        title="部署实例"
                        @click="details(item)"
                      />
                      <button
                        v-if='detailnodesBoolean'
                        class="e-btn e-tbar-btn icon hero-icon hero-icon-confirm"
                        title="环境详情"
                        @click="detailnodes(item)"
                      />
                      <button
                        v-if='editBoolean'
                        class="e-btn e-tbar-btn icon hero-icon hero-icon-edit"
                        title="修改"
                        @click="modify(item)"
                      />
                      <button
                        v-if='removeBoolean'
                        class="e-btn e-tbar-btn icon hero-icon hero-icon-remove"
                        title="删除"
                        @click="deleteone(item)"
                      />
                    </ejs-toolbar>
                  </div>
                </div>
                <div style="text-indent: 5px;line-height:32px;margin-top: 15px;color:#bbb;">环境名：<span style="color: #333333;font-size: 16px;">{{item.k8sName}}</span></div>
                <div style="text-indent: 5px;line-height:32px;color:#bbb;">实例数：<span style="color: #333333;font-size: 16px;">{{item.count}}</span></div>
                <div style="text-indent: 5px;line-height:32px;color:#bbb;">创建时间：<span style="color: #333333;font-size: 16px;">{{item.createTime }}</span></div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-sm-6 col-lg-4 col-md-6">
            <div tabindex="0" class="e-card" id="basic_card">
              <div class="e-card-actions k8s-bg" style="height:200px;background-position: center;text-align:center;cursor:pointer;" @click="addDialogShow">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomDialog
      ref="addEnvDialog"
      :element="dialog.element.addEnvDialog"
      :styles="dialog.element.addEnvDialog.styles"
    >
      <template v-slot:dialog-content>
        <AddDialog ref="addObj"></AddDialog>
      </template>
    </CustomDialog>
    <CustomDialog
      ref="detailEnvDialog"
      :element="dialog.element.detailEnvDialog"
      :styles="dialog.element.detailEnvDialog.styles"
    >
      <template v-slot:dialog-content>
        <DetailDialog ref="detailObj"></DetailDialog>
      </template>
    </CustomDialog>
    <CustomDialog
      ref="detailNodesDialog"
      :element="dialog.element.detailNodesDialog"
      :styles="dialog.element.detailNodesDialog.styles"
    >
      <template v-slot:dialog-content>
        <DetailNodesDialog ref="detailNodesObj"></DetailNodesDialog>
      </template>
    </CustomDialog>
    <CustomDialog
      ref="editEnvDialog"
      :element="dialog.element.editEnvDialog"
      :styles="dialog.element.editEnvDialog.styles"
    >
      <template v-slot:dialog-content>
        <EditDialog ref="editObj"></EditDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from "../../common/CustomDialog";
import { EventBus } from "../../../plugins/eventBus";
import DetailDialog from "./detailDialog";
import AddDialog from "./addDialog";
import DetailNodesDialog from "./detailNodesDialog";
import EditDialog from "./editDialog";

export default {
  name: "Panel",
  props: ["id"],
  data() {
    return {
      synBoolean:JSON.parse(sessionStorage.getItem('authMap')).kubernetes.Sync,
      detailsBoolean:JSON.parse(sessionStorage.getItem('authMap')).kubernetes.DeployedInstance,
      detailnodesBoolean:JSON.parse(sessionStorage.getItem('authMap')).kubernetes.EnvDetails,
      editBoolean:JSON.parse(sessionStorage.getItem('authMap')).kubernetes.Modify,
      removeBoolean:JSON.parse(sessionStorage.getItem('authMap')).kubernetes.Delete,
      panelId: this.id,
      deleteId: "",
      deleteCount: 0,
      widthNum: 3,
      datacards: {},
      dialog: {
        element: {
          //部署实例详情
          detailEnvDialog: {
            refName: "detailEnvDialog",
            isClose: true,
            buttonGroup: [
              {
                click: this.detailEnvDialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              }
            ],
            title: this.$t("部署实例"),
            styles: {
              width: "50%",
              height: "80%",
              model: true,
              visible: false
            }
          },
          addEnvDialog: {
            refName: "addEnvDialog",
            isClose: true,
            buttonGroup: [
              {
                click: this.addEnvDialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              },
              {
                click: this.addEnvDialogconfirm,
                buttonModel: {
                  content: `${this.$t("Common.confirm")}`,
                  isPrimary: true
                }
              }
            ],
            title: this.$t("新增环境"),
            styles: {
              width: "400px",
              height: "auto",
              model: true,
              visible: false
            }
          },
          editEnvDialog: {
            refName: "editEnvDialog",
            isClose: true,
            buttonGroup: [
              {
                click: this.editEnvDialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              },
              {
                click: this.editEnvDialogConfirm,
                buttonModel: {
                  content: `${this.$t("Common.confirm")}`,
                  isPrimary: true
                }
              }
            ],
            title: this.$t("修改环境"),
            styles: {
              width: "400px",
              height: "auto",
              model: true,
              visible: false
            }
          },
          //节点环境详情
          detailNodesDialog: {
            refName: "detailNodesDialog",
            isClose: true,
            buttonGroup: [
              {
                click: this.detailEnvNodesDialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              },
              {
                click: this.detailNodesConfirm,
                buttonModel: {
                  content: `${this.$t("Common.confirm")}`,
                  isPrimary: true
                }
              }
            ],
            title: this.$t("环境详情"),
            styles: {
              width: "50%",
              height: "80%",
              model: true,
              visible: false
            }
          }
        }
      }
    };
  },
  filters: {},
  methods: {
    details(event) {
      this.$refs.detailObj.findEnv(event);
      this.$refs.detailEnvDialog.show();
    },
    addDialogShow() {
      this.$refs.addObj.clear();
      this.$refs.addEnvDialog.show();
      this.$refs.addObj.bindValidate();
    },
    modify(item) {
      this.$refs.editObj.clear();
      this.$refs.editObj.findEnv(item);
      this.$refs.editEnvDialog.show();
      this.$refs.editObj.bindValidate();
    },
    async addEnvDialogconfirm() {
      await this.parentCheckIpRepeatAdd();
      if (this.$refs.addObj.flagCheckIpRepeat) {
        await this.parentCheckAuthCodeAdd();
      }
      const flag = this.$refs.addObj.flagCheckAuthCode;
      if (flag) {
      const params = this.$refs.addObj.getData();
      this.$axios
        .post("/lte/ems/env/createEnvironment.html", params)
        .then(response => {
          if (response && response.status === 200) {
            if (response.data.errorCode === "SUCCESS") {
              this.addEnvDialogHide();
              this.getInitDatas();
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "success",
                content: this.$t("Common.tips.success")
              });
            } else {
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "warning",
                content: "添加失败"
              });
            }
          }
        });
      }
    },
    parentCheckIpRepeatEdit() {
      return this.$refs.editObj.checkIpRepeat();
    },
    parentCheckAuthCodeEdit() {
      return this.$refs.editObj.checkAuthCode();
    },
    parentCheckIpRepeatAdd() {
      return this.$refs.addObj.checkIpRepeat();
    },
    parentCheckAuthCodeAdd() {
      return this.$refs.addObj.checkAuthCode();
    },

    async editEnvDialogConfirm() {
      await this.parentCheckIpRepeatEdit();
      if (this.$refs.editObj.editFlagCheckIpRepeat) {
        await this.parentCheckAuthCodeEdit();
      }
      const flag = this.$refs.editObj.editFlagCheckAuthCode;
      if (flag) {
        const params = this.$refs.editObj.getData();
        this.$axios
          .post("/lte/ems/env/updateEnvironment.html", params)
          .then(response => {
            if (response && response.status === 200) {
              if (response.data.errorCode === "SUCCESS") {
                // this.editEnvDialogHide();
                this.editEnvDialogHide();
                this.getInitDatas();
                this.$loading.hideLoadding();
                EventBus.$emit("toast", {
                  type: "success",
                  content: "修改成功"
                });
              } else {
                this.$loading.hideLoadding();
                EventBus.$emit("toast", {
                  type: "warning",
                  content: "修改失败"
                });
              }
            }
          });
      }
    },
    getInitDatas() {
      const $this = this;
      this.$axios
        .post("/lte/ems/env/getAllEnvironmentList", {
          type: "5G"
        })
        .then(response => {
          console.log("getAllEnvironmentList===response", response);
          const res = response.data.resultVal;
          const showRe = [];
          res.forEach(element => {
            this.axios
              .get("/lte/ems/deployed/queryDeployedInfoAll?envID=" + element.id)
              .then(ress => {
                if (ress.status == 200) {
                  const re = {};
                  re.count = ress.data.resultVal.length;
                  re.createTime = this.formatDate(element.createTime);
                  re.id = element.id;
                  re.k8sAuthCode = element.k8sAuthCode;
                  re.k8sEnvIp = element.k8sEnvIp;
                  re.k8sEnvPort = element.k8sEnvPort;
                  re.k8sLabels = element.k8sLabels;
                  re.k8sName = element.k8sName;
                  re.k8sTaints = element.k8sTaints;
                  showRe.push(re);
                }
              });
          });
          $this.datacards = showRe;
        });
    },
    detailnodes(event) {
      const This = this;
      This.$refs.detailNodesDialog.show();
      This.$refs.detailNodesObj.clearData();
      This.$refs.detailNodesObj.setEnvId(event.id);
    },
    detailNodesConfirm(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return false;}
      const That = this;
      const obj = That.$refs.detailNodesObj.getGridDataNew();
      console.log("obj888====", obj);
      if (obj) {
        That.$axios
          .post("/lte/ems/env/updateLabelsTaints", {
            data: JSON.stringify(obj)
          })
          .then(response => {
            console.log("response", response);
            if (response && response.status === 200) {
              if (response.data.errorCode === "SUCCESS") {
                this.detailEnvNodesDialogHide();
                EventBus.$emit("toast", {
                  type: "success",
                  content: "修改成功"
                });
              } else {
                EventBus.$emit("toast", {
                  type: "warning",
                  content: "修改失败"
                });
              }
            }
          });
      }
    },
    syncnodes(item) {
      this.$layer.confirm({
        msg: "是否同步",
        btn1: {
          msg: this.$t("Topo.cancel")
        },
        btn2: {
          msg: this.$t("Topo.confirm"),
          func: () => {
            this.$axios
              .post("/lte/ems/env/syncEnv.html", item)
              .then(response => {
                if (response && response.status === 200) {
                  if (response.data.errorCode === "SUCCESS") {
                    this.getInitDatas();
                    EventBus.$emit("toast", {
                      type: "success",
                      content: "同步成功"
                    });
                  } else {
                    EventBus.$emit("toast", {
                      type: "warning",
                      content: "同步失败"
                    });
                  }
                }
              });
          }
        }
      });
    },

    deleteone(item) {
      this.deleteId = item.id;
      this.deleteCount = item.count;
      this.$layer.confirm({
        msg: this.$t("Topo.sureDel"),
        btn1: {
          msg: this.$t("Topo.cancel")
        },
        btn2: {
          msg: this.$t("Topo.confirm"),
          func: this.delk8s
        }
      });
    },
    delk8s() {
      if (0 < this.deleteCount) {
        EventBus.$emit("toast", {
          type: "warning",
          content: "实例数不为0，不允许删除"
        });
      } else {
        const params = {
          info: {
            processName: "ems_micropoc",
            type: "5G",
            id: this.deleteId
          },
          vo: ""
        };
        this.axios
          .post("/lte/ems/env/delEnvironment.html", params)
          .then(response => {
            if (response.data === undefined) {
              return;
            }
            if (response.status === 200) {
              if (response.data.errorCode === "SUCCESS") {
                this.getInitDatas();
                EventBus.$emit("toast", {
                  type: "success",
                  content: this.$t("Topo.delSuccess")
                });
              } else {
                EventBus.$emit("toast", {
                  type: "warning",
                  content: response.data.errorString
                });
              }
            }
          });
      }
    },
    addEnvDialogHide() {
      this.$refs.addEnvDialog.clear();
      this.$refs.addEnvDialog.close();
    },
    editEnvDialogHide() {
      this.$refs.editEnvDialog.clear();
      this.$refs.editEnvDialog.close();
    },
    detailEnvDialogHide() {
      this.$refs.detailEnvDialog.clear();
      this.$refs.detailEnvDialog.close();
    },
    detailEnvNodesDialogHide() {
      this.$refs.detailNodesDialog.clear();
      this.$refs.detailNodesDialog.close();
    },
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {
    DetailDialog,
    AddDialog,
    EditDialog,
    CustomDialog,
    DetailNodesDialog
  },
  mounted() {
    this.getInitDatas();
  }
};
</script>
<style scoped>
.card-control-section.basic_card_layout #weather_card.e-card {
}

.card-control-section.basic_card_layout
  #weather_card.e-card
  .e-card-header-caption
  .e-card-header-title,
.card-control-section.basic_card_layout
  #weather_card.e-card
  .e-card-header-caption
  .e-card-sub-title {
  color: white;
}

.highcontrast
  .card-control-section.basic_card_layout
  #weather_card.e-card
  .e-card-header.weather_report
  .e-card-header-image {
  border: none;
}

.card-control-section.basic_card_layout
  #weather_card.e-card
  .weather_report
  .e-card-header-caption {
  text-align: right;
}

.card-control-section.basic_card_layout
  #weather_card.e-card
  .e-card-header.weather_report
  .e-card-header-image {
}

.card-control-section.basic_card_layout .col-xs-6.col-sm-6.col-lg-6.col-md-6 {
  width: 100%;
  padding: 10px;
}

.card-control-section.basic_card_layout .card-layout {
  margin: auto;
  max-width: 400px;
}

@media (min-width: 870px) {
  .card-control-section.basic_card_layout .col-xs-6.col-sm-6.col-lg-6.col-md-6 {
    width: 50%;
  }

  .card-control-section.basic_card_layout .card-layout {
    max-width: calc(100% - 40px);
  }
}
.e-toolbar{
  background:none!important;
}

</style>
